export default "__VITE_ASSET__CnObf3AX__"